AppTabs.createTab( {
name: 'import-parameter-translation-settings',
icon: 'upload',
text: 'Import Parameter Translation Settings',
create: function(init) {
	'use strict'

	init.setDataTableArgs( {

		tableId: 		'#data-table-import-parameter-translation-settings',

		readTableName: 	'tblImportParameterTranslationSettings',
		editTableName: 	'tblImportParameterTranslationSettings',
		primaryKey: 	'ImportParameterTranslationSettingsID',

		canCreate: 			true,
		canEdit: 			true,
		canRemove: 			true,
		hasColumnFilters: 	true,
		canSearch: 			true,
		canSort:            true,
		paging:				false,

		actionData:			'datatable',
		actionCreate:		'datatable_create',
		actionEdit:			'datatable_edit',
		actionRemove:		'datatable_remove',

		editCallback:		function() {
			window.broadcastLocalStorageUpdateRequest( 'importParameterTranslationMap' );
		},

		fields: [
			{
				label: 		'Import Type',
				columnName: 'ImportType',
				isEditable: true,
				sort:		'asc',
			},
			{
				label: 		'In Parameter',
				columnName: 'InParameter',
				isEditable: true,
				sort:		'asc',
			},
			{
				label: 		'In Test',
				columnName: 'InTest',
				isEditable: true,
				sort:		'asc',
			},
			{
				label: 		'In Method',
				columnName: 'InMethod',
				isEditable: true,
				sort:		'asc',
			},
			{
				label: 		'Out Test',
				columnName: 'OutTestID',
				isEditable: true,
				type:		'maybe-test',
				render: 	DataTablesManager.getTestNameByID,
			},
			{
				label: 		'Out Method',
				columnName: 'OutMethod',
				isEditable: true,
			},

		],

	} );
}
} );
